import Markdown, { MarkdownStyle } from "../components/markdown/Markdown";
import Container from "../components/Container";
import { Helmet } from "react-helmet";

import { useEffect, useState } from "react";
import { IBlogRecord } from "../lib/types";
import pb from "../lib/pocketbase";
import { useNavigate, useParams } from "react-router-dom";

import Button from "../components/form/button";
import { config } from "../config";
import Loading from "../components/Loading";

export default function BlogPost() {
    const navigate = useNavigate();
    const id = useParams().id;
    const [loading, setLoading] = useState(true);
    const [blogPost, setBlogPost] = useState<IBlogRecord>();

    useEffect(() => {
        async function load() {
            if (!id) return;
            const bp: IBlogRecord = await pb.collection("blog").getOne(id);
            setBlogPost(bp);
            setLoading(false);
        }
        load();
    }, [id]);

    const banner = config.pocketbase + "/api/files/" + blogPost?.collectionId + "/" + blogPost?.id + "/" + blogPost?.banner;

    return (
        <>
            {loading && (
                <div className="mt-8 flex w-full items-center justify-center">
                    <Loading />
                </div>
            )}
            {blogPost ? (
                <>
                    <Helmet>
                        <title>ReinVB — Blog — {blogPost.title}</title>
                        <meta name="description" content="The latest and greatest blogposts of Rein." />
                    </Helmet>
                    <Container className="mt-4 max-w-3xl lg:mt-8 xl:mt-16">
                        <Button onClick={() => navigate(-1)} variant={"ghost"} size={"ghost"} className="mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-R h-4">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75" />
                            </svg>
                            Back
                        </Button>
                        <MarkdownStyle className="mb-8 max-w-full">
                            <h1>{blogPost.title}</h1>
                            {blogPost.banner && <img src={banner} alt="" />}
                        </MarkdownStyle>
                        <Markdown className="max-w-full">{blogPost.content}</Markdown>
                    </Container>
                </>
            ) : (
                <></>
            )}
        </>
    );
}
